import React, { ReactElement } from 'react';
import useDeleteWidget from 'adapter/in/dashboards/hooks/Widget/useDeleteWidget';
import ConfirmChangesModal from 'adapter/in/common/components/ConfirmActionModal/ConfirmActionModal';
import i18n from 'asset/translation';
import gtmIds from 'adapter/in/dashboards/config/gtm';

type DeleteWidgetModalContainerProps = {
    dashboardId: string;
    widgetId: string;
    showModal: boolean;
    setShowModal: (show: boolean) => void;
};
const gtm = gtmIds.widget.deleteModal;

const DeleteWidgetModalContainer = (props: DeleteWidgetModalContainerProps): ReactElement => {
    const { dashboardId, showModal, setShowModal, widgetId } = props;

    const { delete: deleteWidget, isLoading, error } = useDeleteWidget(dashboardId, widgetId);

    return (
        <ConfirmChangesModal
            isOpen={showModal}
            onClose={() => {
                setShowModal(false);
            }}
            onProceed={deleteWidget}
            proceedButtonVariant='destructive'
            isLoading={isLoading}
            hasError={error}
            proceedButtonText={i18n.t('widgets.delete.yes')}
            message={i18n.t('widgets.delete.warningMsg')}
            title={i18n.t('widgets.actionDelete')}
            dataIdContext={{ proceed: gtm.actions.delete, cancel: gtm.actions.cancel, tryAgain: gtm.actions.tryAgain }}
        />
    );
};

export default DeleteWidgetModalContainer;
